import { SatosLinkLocation } from "@/app/application/SATOSLink";

export class SearchResponse {
	Items: Array<SearchResponseItem>;
}

export class SearchResponseItem {
	Id: string;
	Title: string;
	Body: string;
	Category: SearchResponseCategory;
	Location: SatosLinkLocation;
	ProcedureId: number;
	ProcedureNameHit: boolean;
	TagHit: boolean;
}

export type SearchResponseCategory = "Procedure" | "MaterialHandling";

export type fetchSearchConfiguration = {
	minimumSearchTermLength: number;
};

export const USE_FETCH_SEARCH_CONFIGURATION: fetchSearchConfiguration = {
	minimumSearchTermLength: 3,
};
